export default __webpack_public_path__ + "static/tkmaxx-promo--2024-2f752806ca2d1a225aca8aae20576f2a.jpg";